import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/duanju',
    component: () => import('@/layout/index.vue'),
    redirect: '/duanju/list',
    meta: { title: '短剧管理', icon: 'el-icon-video-camera' },
    children: [
      {
        path: 'list',
        name: 'DuanjuList',
        component: () => import('@/views/duanju/list.vue'),
        meta: { title: '短剧列表', icon: 'el-icon-video-camera' }
      },
      {
        path: 'edit/:id?',
        name: 'DuanjuEdit',
        component: () => import('@/views/duanju/edit.vue'),
        meta: { title: '短剧编辑', activeMenu: '/duanju/list' },
        hidden: true
      },
      {
        path: 'episode/:duanjuId',
        name: 'DuanjuEpisode',
        component: () => import('@/views/duanju/episode.vue'),
        meta: { title: '剧集管理', activeMenu: '/duanju/list' },
        hidden: true
      },
      {
        path: 'category',
        name: 'DuanjuCategory',
        component: () => import('@/views/duanju/category.vue'),
        meta: { title: '分类管理', icon: 'el-icon-menu' }
      }
    ]
  },
  {
    path: '/drama',
    component: () => import('@/layout/index.vue'),
    redirect: '/drama/manage',
    meta: { title: '微信短剧媒资', icon: 'el-icon-share' },
    children: [
      {
        path: 'manage',
        name: 'WxDramaManage',
        component: () => import('@/views/drama/manage.vue'),
        meta: { title: '媒资管理', icon: 'el-icon-upload2' }
      },
      {
        path: 'monetization',
        name: 'DramaMonetization',
        component: () => import('@/views/drama/monetization.vue'),
        meta: { title: '变现配置', icon: 'el-icon-coin' }
      }
    ]
  },
  {
    path: '/user',
    component: () => import('@/layout/index.vue'),
    redirect: '/user/sys',
    meta: { title: '用户管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'sys',
        name: 'SysUser',
        component: () => import('@/views/user/sys.vue'),
        meta: { title: '系统用户', icon: 'el-icon-s-custom' }
      },
      {
        path: 'duanju',
        name: 'DuanjuUser',
        component: () => import('@/views/user/duanju.vue'),
        meta: { title: '短剧用户', icon: 'el-icon-user-solid' }
      }
    ]
  }
]

const router = new VueRouter({
  routes: constantRoutes
})

router.beforeEach((to, from, next) => {
  const hasToken = store.getters.token
  if (to.path === '/login') {
    if (hasToken) {
      next('/')
    } else {
      next()
    }
  } else {
    if (hasToken) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
